import React, { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import {
  TbAddressBook,
  TbArrowsExchange,
  TbBuilding,
  TbBuildingCommunity,
  TbBuildingSkyscraper,
  TbCalendar,
  TbCurrentLocation,
  TbFileDescription,
  TbFileDollar,
  TbFileInvoice,
  TbMap2,
  TbMapPin,
  TbPencil,
  TbPhotoPin,
  TbSettings,
  TbUserPlus,
  TbWorld,
} from "react-icons/tb";

import dayjs from "dayjs";
import { useAuthContext } from "../../../context/authContext";
import {
  Box,
  Button,
  Checkbox,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../ppui";
import { Snackbar } from "../../../ppui/snackbar";
import { theme } from "../../../theme";
import {
  formatToDDMMYYYY,
  parseNumericValue,
  sliceText,
} from "../../../utils/common";
import useCommonfn from "../../../utils/useCommonfn";
import {
  Card,
  CardHeading,
  CustomTable,
  CustomTableBody,
  CustomTableFooter,
  CustomTableHeader,
  OrganizationBx,
  OrganizationEmDetails,
  Td,
  Th,
  Tr,
} from "../../style";
import { EPF_INPUT_FIELDS } from "./epf-constant";
import useEpfService from "./use-epf-service";

function StatutoryEpf() {
  const {
    handleViewClose,
    view,
    handleClickOpen,
    handleClose,
    open,
    handleSubmitFn,
    createUpdateLoading,
    getInputFieldPropsFn,
    stateList,
    handleDisableAllEpfFn,
    epfInputs,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    getProfileLoading,
    viewEpfDetails,
    openStatutoryEPFModal,
    handleOpenStatutoryEPFModal,
    handleCloseStatutoryEPFModal,
    openEPFAddressModal,
    handleOpenEPFAddressModal,
    handleCloseEPFAddressModal,
    getStateName,
  } = useEpfService();
  const { navigateToDashBoard } = useCommonfn();

  const { orgDetails } = useAuthContext();
  // setEPFInputs(prev=>({ ...prev, epfOrganizationEmployeeContribution: prev?.epfOrganizationEmployeeContribution?prev?.epfOrganizationEmployeeContribution: 'restrict_contribution',epfOrganizationStatus: prev?.epfOrganizationStatus? prev?.epfOrganizationStatus:  "12%",epfOrganizationEmployerContribution: prev?.epfOrganizationEmployerContribution? prev?.epfOrganizationEmployerContribution: 'restrict_contribution'}))
  const epfOrganizationEmployerContribution =
    epfInputs?.epfOrganizationEmployerContribution || "restrict_contribution";
  const epfOrganizationEmployeeContribution =
    epfInputs?.epfOrganizationEmployeeContribution || "restrict_contribution";
  const epfOrganizationStatus = epfInputs?.epfOrganizationStatus || "12%";

  const [employeeAssumeSalary, setEmployeeAssumeSalary] = useState(20000);
  let epsAmount = 0;
  let employeerContributionAmount = 15000;
  let employeeContributionAmount = 15000;
  const epfOrganizationStatus10Or12 = parseInt(epfOrganizationStatus);

  if (epfOrganizationEmployerContribution === "restrict_contribution") {
    employeerContributionAmount =
      employeeAssumeSalary > 15000 ? 15000 : employeeAssumeSalary;
    epsAmount = (employeerContributionAmount * 8.33) / 100;
  } else {
    epsAmount =
      (employeeAssumeSalary * 8.33) / 100 > 1250
        ? 1250
        : (employeeAssumeSalary * 8.33) / 100;
    employeerContributionAmount = employeeAssumeSalary;
  }

  if (epfOrganizationEmployeeContribution !== "restrict_contribution") {
    employeeContributionAmount = employeeAssumeSalary;
  } else {
    employeeContributionAmount =
      employeeAssumeSalary > 15000 ? 15000 : employeeAssumeSalary;
  }
  if (getProfileLoading) {
    return <Box>Loading...</Box>;
  }

  return (
    <>
      {!viewEpfDetails?.epfOrganizationNumber ? (
        <>
          <Flex justifyContent="space-between" mb={20}>
            <Box>
              <Typography variant="h5" mb={"0"}>
                {`Employee's Provident Fund`}
              </Typography>
              <Typography variant="body2" mb={"0"}>
                {`Deduction Circle: Monthly`}
              </Typography>
            </Box>
            <Switchbox
              label={`${epfInputs.epfOrganizationIsDisabled ? "Enable" : "Disable"} EPF`}
              color="Primary"
              size="lg"
              lableFirst
              checked={!epfInputs.epfOrganizationIsDisabled}
              onChange={handleDisableAllEpfFn}
            />
          </Flex>

          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationNumber.name
                )}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationStatus.name
                )}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationCoverageDate.name
                )}
                valueSinc
                onKeyDown={(e) => e.preventDefault()}
                min={dayjs(orgDetails?.date_of_org).format("YYYY-MM-DD")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationOffice.name
                )}
              />
            </Col>

            <Col sm={12} md={6}>
              <SelectField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationEmployeeContribution.name
                )}
              />
            </Col>

            <Col sm={12} md={6}>
              <SelectField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationEmployerContribution.name
                )}
              />
            </Col>
          </Row>

          <Divider gap={20} />

          <Typography variant="h5">EPF Address</Typography>
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationAddress.name
                )}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationCity.name
                )}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationState.name
                )}
                options={stateList || []}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                disabled
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationCountry.name
                )}
                value={"India"}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationPinCode.name
                )}
              />
            </Col>

            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationLocation.name
                )}
              />
            </Col>
          </Row>

          <Divider gap={20} />

          <Flex direction="column" gap={20} mb={"20"}>
            <Flex alignItem="center" gap={10}>
              <Checkbox
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationMaster1.name
                )}
              />
              <Typography variant="h6" mb={"0"}>
                {`Including employer's contribution in the CTC`}
              </Typography>
            </Flex>

            <Flex alignItem="center" pl={"40"}>
              <Checkbox
                // {...getInputFieldPropsFn(EPF_INPUT_FIELDS.epfOrganizationLocation.name)}
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationMaster2.name
                )}
              />
              {/* <Epffileicon> {<TbInfoCircle />} </Epffileicon> */}
            </Flex>

            <Flex alignItem="center" pl={"40"}>
              <Checkbox
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationMaster3.name
                )}
              />

              {/* <Epffileicon> {<TbInfoCircle />} </Epffileicon> */}
            </Flex>

            <Flex alignItem="center" gap={10}>
              <Checkbox
                {...getInputFieldPropsFn(
                  EPF_INPUT_FIELDS.epfOrganizationMaster4.name
                )}
              />
              <Typography variant="h6" mb={"0"}>
                Override PF contribution rate at employee level
              </Typography>
            </Flex>
          </Flex>

          <Button
            disabled={epfInputs.epfOrganizationIsDisabled === true}
            color="primary"
            onClick={handleClickOpen}
            variant="outlined"
          >
            View Split up
          </Button>

          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button
              color="primary"
              onClick={navigateToDashBoard}
              variant="outlined"
              disabled={epfInputs.epfOrganizationIsDisabled}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleSubmitFn}
              loading={createUpdateLoading}
              variant="contained"
              disabled={epfInputs.epfOrganizationIsDisabled}
            >
              Save
            </Button>
          </Flex>
        </>
      ) : (
        <>
          <Card>
            <CardHeading Divider>
              {`Employee's`} Under Provident Fund Details
              <FabButton
                size="sm"
                icon={<TbPencil />}
                onClick={handleOpenStatutoryEPFModal}
                variant="filled"
                shape="box"
              />
            </CardHeading>
            <OrganizationEmDetails>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbFileInvoice /> {/* Good for EPF Number */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    EPF Number
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {viewEpfDetails?.epfOrganizationNumber || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbFileDescription /> {/* Good for EPF Status */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    EPF Status
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {viewEpfDetails?.epfOrganizationStatus === "12%"
                      ? "Unexempted 12%"
                      : viewEpfDetails?.epfOrganizationStatus === "10%"
                        ? "Exempted 10%"
                        : "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbUserPlus /> {/* Good for Employee Contribution */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Employee Contribution
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {viewEpfDetails?.epfOrganizationEmployeeContribution ===
                    "restrict_contribution"
                      ? "Restrict Contribution To ₹ 15000 Of PF Wages"
                      : viewEpfDetails?.epfOrganizationEmployeeContribution ===
                          "unrestricted_contribution"
                        ? "Unrestricted Contribution (Based on Actual Wages)"
                        : "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBuilding /> {/* Good for Employer Contribution */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Employer Contribution
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {viewEpfDetails?.epfOrganizationEmployerContribution ===
                    "restrict_contribution"
                      ? "Restrict Contribution To ₹ 15000 Of PF Wages"
                      : viewEpfDetails?.epfOrganizationEmployerContribution ===
                          "unrestricted_contribution"
                        ? "Unrestricted Contribution (Based on Actual Wages)"
                        : "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCalendar /> {/* Good for Coverage Date */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Coverage Date
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {formatToDDMMYYYY(
                      new Date(viewEpfDetails?.epfOrganizationCoverageDate)
                    ) || "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbArrowsExchange />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Deduction Circle
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    Monthly
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBuildingSkyscraper /> {/*  Good for Office/Organization */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Under EPF Office
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {viewEpfDetails?.epfOrganizationOffice || "Not Assigned"}
                  </Typography>
                </Box>
              </OrganizationBx>
              <Divider />
              <Flex gap={10} direction="column">
                <Flex gap={10}>
                  <Icon size={"lg"}>
                    <TbFileDollar />
                  </Icon>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Including {`employer's`} contribution in the CTC : {`  `}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    mb={"0"}
                    color={
                      viewEpfDetails?.epfOrganizationMaster1
                        ? "success"
                        : "danger"
                    }
                    textCase="capitalize"
                  >
                    {`  `}{" "}
                    {viewEpfDetails?.epfOrganizationMaster1 ? "Yes" : "No"}
                  </Typography>
                </Flex>

                <Flex gap={10}>
                  <Icon size={"lg"}>
                    <TbFileDollar />
                  </Icon>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Include admin charges & {`employer's`} EDLI contribution in
                    the CTC : {`  `}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    mb={"0"}
                    color={
                      viewEpfDetails?.epfOrganizationMaster2
                        ? "success"
                        : "danger"
                    }
                    textCase="capitalize"
                  >
                    {viewEpfDetails?.epfOrganizationMaster2 ? "Yes" : "No"}
                  </Typography>
                </Flex>

                <Flex gap={10}>
                  <Icon size={"lg"}>
                    <TbSettings />
                  </Icon>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Override PF contribution rate at employee level : {`  `}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    mb={"0"}
                    color={
                      viewEpfDetails?.epfOrganizationMaster4
                        ? "success"
                        : "danger"
                    }
                    textCase="capitalize"
                  >
                    {viewEpfDetails?.epfOrganizationMaster4 ? "Yes" : "No"}
                  </Typography>
                </Flex>
              </Flex>
            </OrganizationEmDetails>
            <Divider gap={20} />

            <Button
              disabled={epfInputs.epfOrganizationIsDisabled === true}
              color="primary"
              onClick={handleClickOpen}
              variant="outlined"
            >
              View Split up
            </Button>
          </Card>
          <Card>
            <CardHeading Divider>
              EPF Address Details
              {viewEpfDetails?.epfOrganizationAddress &&
              viewEpfDetails?.epfOrganizationCity &&
              getStateName(viewEpfDetails?.epfOrganizationState) &&
              viewEpfDetails?.epfOrganizationPinCode ? (
                <FabButton
                  size="sm"
                  icon={<TbPencil />}
                  onClick={handleOpenEPFAddressModal}
                  variant="filled"
                  shape="box"
                />
              ) : (
                <FabButton
                  size="sm"
                  icon={<TbAddressBook />}
                  onClick={handleOpenEPFAddressModal}
                  variant="contained"
                  shape="extended"
                  color="primary"
                >
                  {" "}
                  Add
                </FabButton>
              )}
            </CardHeading>

            <OrganizationEmDetails>
              {viewEpfDetails?.epfOrganizationAddress &&
              viewEpfDetails?.epfOrganizationCity &&
              getStateName(viewEpfDetails?.epfOrganizationState) &&
              viewEpfDetails?.epfOrganizationPinCode ? (
                <>
                  <OrganizationBx>
                    <Icon size={"lg"}>
                      <TbMapPin /> {/* Good for Address */}
                    </Icon>
                    <Box>
                      <Typography variant="body1" mb={"0"} color="primary">
                        Address
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize"
                      >
                        {viewEpfDetails?.epfOrganizationAddress || "-"}
                      </Typography>
                    </Box>
                  </OrganizationBx>

                  <OrganizationBx>
                    <Icon size={"lg"}>
                      <TbBuildingCommunity /> {/* Good for City */}
                    </Icon>
                    <Box>
                      <Typography variant="body1" mb={"0"} color="primary">
                        City
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize"
                      >
                        {viewEpfDetails?.epfOrganizationCity || "-"}
                      </Typography>
                    </Box>
                  </OrganizationBx>

                  <OrganizationBx>
                    <Icon size={"lg"}>
                      <TbMap2 /> {/* Good for State */}
                    </Icon>
                    <Box>
                      <Typography variant="body1" mb={"0"} color="primary">
                        State
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize"
                      >
                        {getStateName(viewEpfDetails?.epfOrganizationState)}
                      </Typography>
                    </Box>
                  </OrganizationBx>

                  <OrganizationBx>
                    <Icon size={"lg"}>
                      <TbWorld /> {/* Good for Country */}
                    </Icon>
                    <Box>
                      <Typography variant="body1" mb={"0"} color="primary">
                        Country
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize"
                      >
                        India
                      </Typography>
                    </Box>
                  </OrganizationBx>

                  <OrganizationBx>
                    <Icon size={"lg"}>
                      <TbCurrentLocation /> {/*Postal Code*/}
                    </Icon>
                    <Box>
                      <Typography variant="body1" mb={"0"} color="primary">
                        PIN Code
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize"
                      >
                        {viewEpfDetails?.epfOrganizationPinCode || "-"}
                      </Typography>
                    </Box>
                  </OrganizationBx>

                  <OrganizationBx>
                    <Icon size={"lg"}>
                      <TbPhotoPin /> {/* Location Icon */}
                    </Icon>
                    <Box>
                      <Typography variant="body1" mb={"0"} color="primary">
                        Location
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize"
                      >
                        {viewEpfDetails?.epfOrganizationLocation || "-"}
                      </Typography>
                    </Box>
                  </OrganizationBx>
                </>
              ) : (
                <>
                  <Flex alignItem="center">
                    <Typography variant="body2" mb={"0"}>
                      Please enter your EPF Office Address Details for better
                      visibility.
                    </Typography>
                    <Button
                      color="secondary"
                      size="sm"
                      onClick={handleOpenEPFAddressModal}
                    >
                      Click here
                    </Button>
                  </Flex>
                </>
              )}
            </OrganizationEmDetails>
          </Card>
        </>
      )}

      {/* Modal */}
      <Dialog
        title="Sample EPF Calculation"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={() => alert("Submitted")}
        action={false}
        bodyScroll={true}
      >
        <InputField
          variant="standard"
          type="number"
          onChange={(e) =>
            setEmployeeAssumeSalary(sliceText(e.target.value, 12))
          }
          fullWidth
          label={`Let's assume the PF wage is`}
          suffix={"₹"}
          value={employeeAssumeSalary}
        />
        <Gap height={20} />

        <Box
          px={10}
          py={15}
          style={{ borderRadius: theme.radius.list }}
          bgColor={theme.colors.background.main}
          mb={15}
        >
          <Typography
            variant="body2"
            color="primary"
            colorVariant="light"
            fontWeight={500}
          >
            Contribution Rate :{" "}
            {epfOrganizationStatus10Or12 === 12
              ? "Unexempted 12%"
              : "Exempted 10%"}
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            colorVariant="light"
            fontWeight={500}
          >
            PF Contribution Settings
          </Typography>
          <Flex gap={10}>
            <Typography variant="body2" color="primary" colorVariant="light">
              Employee Contribution
            </Typography>
            <Typography variant="body2" color="primary" colorVariant="light">
              :
            </Typography>
            <Typography variant="body2" colorVariant="light">
              {" "}
              {epfOrganizationEmployeeContribution === "restrict_contribution"
                ? "Restrict"
                : "Unrestricted"}{" "}
              Contribution (Based on Actual Wages)
            </Typography>
          </Flex>
          <Flex gap={10} mb={10}>
            <Typography variant="body2" color="primary" colorVariant="light">
              Employer Contribution
            </Typography>
            <Typography variant="body2" color="primary" colorVariant="light">
              :
            </Typography>
            <Typography variant="body2" colorVariant="light">
              {epfOrganizationEmployerContribution === "restrict_contribution"
                ? "Restrict"
                : "Unrestricted"}{" "}
              Contribution (Based on Actual Wages)
            </Typography>
          </Flex>
        </Box>
        <Typography variant="body2" color="default" colorVariant="light">
          The breakup of contribution will be:
        </Typography>
        <Divider gap={15} />
        <Box>
          <Typography variant="body1" color="primary" fontWeight={500}>
            Employee{"'"}s Contribution
          </Typography>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" mb="0">
              EPF ({epfOrganizationStatus10Or12}% of{" "}
              {employeeContributionAmount})
            </Typography>
            <Typography variant="body2" mb="0">
              ₹{" "}
              {parseNumericValue(
                epfOrganizationStatus10Or12 * (employeeContributionAmount / 100)
              ).toFixed()}
            </Typography>
          </Flex>
          <Divider gap={15} />
          <Typography variant="body1" color="primary" fontWeight={500}>
            Employer{"'"}s Contribution
          </Typography>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2">
              EPS (8.33% of Wages (Maximum limit ₹1,250))
            </Typography>
            <Typography variant="body2">₹ {epsAmount.toFixed()}</Typography>
          </Flex>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" mb="0">
              EPF ({epfOrganizationStatus10Or12}% of{" "}
              {employeerContributionAmount} - EPS)
            </Typography>
            <Typography variant="body2" mb="0">
              ₹{" "}
              {parseNumericValue(
                (employeerContributionAmount * epfOrganizationStatus10Or12) /
                  100 -
                  epsAmount
              ).toFixed()}
            </Typography>
          </Flex>
          <Divider gap={15} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" color="primary" fontWeight={500} mb="0">
              Total{" "}
            </Typography>
            <Typography variant="body2" color="primary" fontWeight={500} mb="0">
              ₹{" "}
              {parseNumericValue(
                epsAmount +
                  parseNumericValue(
                    (employeerContributionAmount *
                      epfOrganizationStatus10Or12) /
                      100
                  ) -
                  parseNumericValue(epsAmount)
              ).toFixed()}
            </Typography>
          </Flex>
          <Divider gap={15} />
          {/*<Typography variant="body2" color='default' colorVariant='light'>Do you want to preview EPF calculation for multiple cases, based on the preferences you have configured?</Typography>
            <Button
              color="primary"
              onClick={handleViewOpen}
              fullWidth={true}
              variant="outlined"
            >
              Preview EPF Calculation
            </Button> */}
        </Box>
      </Dialog>
      <Dialog
        title="Sample EPF Calculation"
        closeButton={true}
        fullWidth
        maxWidth="lg"
        open={view}
        onClose={handleViewClose}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Box style={{ width: "100%" }}>
          <Typography variant="body2" color="default" colorVariant="light">
            Let{"'"}s assume the salary packages considered for EPF is as shown
            below, the calculation is based on the settings we have configured.
          </Typography>
          <Flex alignItem="center">
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              mb="0"
            >
              Show current configuration :
            </Typography>
            <FabButton
              color="background"
              icon={<MdKeyboardArrowDown />}
              onClick={() => {}}
            />
          </Flex>
          <Box px={10} py={15} bgColor={theme.colors.background.main} mb={15}>
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              PF CONTRIBUTION SETTINGS
            </Typography>
            <Flex gap={10}>
              <Typography variant="body2" color="primary" colorVariant="light">
                Employer Contribution
              </Typography>
              <Typography variant="body2" color="primary" colorVariant="light">
                :
              </Typography>
              <Typography variant="body2" colorVariant="light">
                {" "}
                {epfOrganizationEmployeeContribution === "restrict_contribution"
                  ? "Restrict"
                  : "Unrestricted"}{" "}
                Contribution to ₹15,000 of PF Wage
              </Typography>
            </Flex>
            <Flex gap={10} mb={10}>
              <Typography variant="body2" color="primary" colorVariant="light">
                Employee Contribution
              </Typography>
              <Typography variant="body2" color="primary" colorVariant="light">
                :
              </Typography>
              <Typography variant="body2" colorVariant="light">
                {epfOrganizationEmployerContribution === "restrict_contribution"
                  ? "Restrict"
                  : "Unrestricted"}{" "}
                Contribution to ₹15,000 of PF Wage
              </Typography>
            </Flex>
            <Typography
              variant="body2"
              color="primary"
              colorVariant="light"
              fontWeight={500}
            >
              LOP CONTRIBUTION
            </Typography>
            <Flex gap={10}>
              <Typography variant="body2" color="primary" colorVariant="light">
                Pro-rate Restricted PF Wage
              </Typography>
              <Typography variant="body2" color="primary" colorVariant="light">
                :
              </Typography>
              <Typography variant="body2" colorVariant="light">
                Enabled
              </Typography>
            </Flex>
            <Flex gap={10}>
              <Typography
                variant="body2"
                color="primary"
                colorVariant="light"
                mb="0"
              >
                Consider all components when PF wage {"<"} ₹15,000 after LOP
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                colorVariant="light"
                mb="0"
              >
                :
              </Typography>
              <Typography variant="body2" colorVariant="light" mb="0">
                Enabled
              </Typography>
            </Flex>
          </Box>
          <Flex justifyContent="space-between" mb={20}>
            <Box>
              <Typography variant="h5" color="primary" mb={"0"}>
                Salary and EPF Calculation
              </Typography>
            </Box>
            <Switchbox
              label="With 15 days LOP"
              color="Primary"
              size="lg"
              lableFirst
            />
          </Flex>
          <CustomTable>
            <CustomTableHeader>
              <Tr>
                <Th>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb={"0"}
                  >
                    SALARY COMPONENTS
                  </Typography>
                </Th>
                <Th align="right">
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb={"0"}
                  >
                    PACKAGE 1
                  </Typography>
                </Th>
                <Th align="right">
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb={"0"}
                  >
                    PACKAGE 2
                  </Typography>
                </Th>
                <Th align="right">
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb={"0"}
                  >
                    PACKAGE 3
                  </Typography>
                </Th>
              </Tr>
            </CustomTableHeader>

            <CustomTableBody>
              <Tr>
                <Td>
                  <Typography variant="body1" mb={"0"}>
                    Basic
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    Always considered for EPF
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 25000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 18000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 12000
                  </Typography>
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <Typography variant="body1" mb={"0"}>
                    Transport Allowance
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    Considered for EPF only when PF wage {"<"} ₹ 15,000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 4000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 2000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 15000
                  </Typography>
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <Typography variant="body1" mb={"0"}>
                    Transport Allowance
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    Considered for EPF only when PF wage {"<"} ₹ 15,000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 4000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 2000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 15000
                  </Typography>
                </Td>
              </Tr>
            </CustomTableBody>

            <CustomTableFooter>
              <Tr>
                <Td>
                  <Typography
                    variant="body1"
                    color="primary"
                    fontWeight={500}
                    mb={"0"}
                  >
                    EPF Contribution
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 1800
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    {epfOrganizationStatus} of 15000
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 2000
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    {epfOrganizationStatus} of 14500
                  </Typography>
                </Td>
                <Td align="right">
                  <Typography variant="body1" mb={"0"}>
                    ₹ 2000
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    {epfOrganizationStatus} of 14500
                  </Typography>
                </Td>
              </Tr>
            </CustomTableFooter>
          </CustomTable>
        </Box>
      </Dialog>
      {/* Modal */}

      {/* Statutory-EPF-Modal */}
      <Dialog
        title="Employee's Under Provident Fund Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openStatutoryEPFModal}
        onClose={handleCloseStatutoryEPFModal}
        onSubmit={handleSubmitFn}
        separator
        footer={
          <>
            <Box mr="auto">
              <Switchbox
                label={`${epfInputs.epfOrganizationIsDisabled ? "Enable" : "Disable"} EPF`}
                color="Primary"
                size="lg"
                checked={!epfInputs.epfOrganizationIsDisabled}
                onChange={handleDisableAllEpfFn}
              />
            </Box>
          </>
        }
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationNumber.name
              )}
            />
          </Col>
          <Col sm={6}>
            <SelectField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationStatus.name
              )}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationCoverageDate.name
              )}
              valueSinc
              onKeyDown={(e) => e.preventDefault()}
              min={dayjs(orgDetails?.date_of_org).format("YYYY-MM-DD")}
            />
          </Col>
          <Col sm={6}>
            <SelectField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationEmployeeContribution.name
              )}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationEmployerContribution.name
              )}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationOffice.name
              )}
            />
          </Col>
        </Row>
        <Divider gap={20} />

        <Flex direction="column" gap={20} mb={"20"}>
          <Flex alignItem="center" gap={10}>
            <Checkbox
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationMaster1.name
              )}
            />
            <Typography variant="h6" mb={"0"}>
              {`Including employer's contribution in the CTC`}
            </Typography>
          </Flex>

          <Flex alignItem="center">
            <Checkbox
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationMaster2.name
              )}
            />
            {/* <Epffileicon> {<TbInfoCircle />} </Epffileicon> */}
          </Flex>

          {/* <Flex alignItem="center" pl={"40"}>
            <Checkbox

              {...getInputFieldPropsFn(EPF_INPUT_FIELDS.epfOrganizationMaster3.name)}
            />

            <Epffileicon> {<TbInfoCircle />} </Epffileicon>
          </Flex> */}

          <Flex alignItem="center" gap={10}>
            <Checkbox
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationMaster4.name
              )}
            />
            <Typography variant="h6" mb={"0"}>
              Override PF contribution rate at employee level
            </Typography>
          </Flex>
        </Flex>
      </Dialog>
      {/* Statutory-EPF-Modal */}

      {/* Statutory-EPF-Address */}
      <Dialog
        title="EPF Address Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openEPFAddressModal}
        onClose={handleCloseEPFAddressModal}
        onSubmit={handleSubmitFn}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationAddress.name
              )}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationCity.name
              )}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationState.name
              )}
              options={stateList || []}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              disabled
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationCountry.name
              )}
              value={"India"}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationPinCode.name
              )}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(
                EPF_INPUT_FIELDS.epfOrganizationLocation.name
              )}
            />
          </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Address */}

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default StatutoryEpf;
